import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import SelectCreator from "../../../../components/Forms/components/SelectCreator";
import InputCreator from "../../../../components/Forms/components/InputCreator";
import Button from "../../../../components/Button";
import {
  requestAdvancedProbeTypes,
  requestSlaveList,
  updateSlave,
} from "../../../../redux/Actions/advanceTab.action";
import {
  getProbeTypes,
  getSlaveList,
} from "../../../../redux/Selectors/advanceTab.selector";

const SlaveAddressUtility = () => {
  const dispatch = useDispatch();
  const probesTypeList = useSelector(getProbeTypes);
  const slaveList = useSelector(getSlaveList);
  const [probeType, setProbeType] = useState(null);
  const [oldPin, setOldPin] = useState(null);
  const [newPin, setNewPin] = useState(null);

  useEffect(() => {
    dispatch(requestAdvancedProbeTypes());
  }, [dispatch]);

  const handleProbeChange = (e) => {
    const selectedProbe = e.target.value;
    dispatch(requestSlaveList(selectedProbe));
    setProbeType(selectedProbe);
  };

  const handleSubmit = () => {
    const callback = () => {
      setProbeType("");
      setOldPin("");
      setNewPin("");
    };
    const payload = {old_pin: oldPin, new_pin: newPin};
    dispatch(updateSlave(probeType, payload, callback));
  };

  return (
    <div>
      <div className="advance-form-heading">Slave Address Utility</div>
      <div className="advance-tab-form-container">
        <div className="d-flex advance-tab-input-container">
          <div className="advance-tab-input-label">Choose Probe Type</div>
          <div className="advance-tab-input">
            <SelectCreator
              closeMenuOnSelect={true}
              options={probesTypeList}
              onChange={handleProbeChange}
              value={probeType}
              colSize={12}
              placeholder={"Select Probe Type"}
              classNamePrefix={"advanced_probe_type"}
              id={"advanced_probe_type"}
            />
          </div>
        </div>
        <div className="d-flex advance-tab-input-container">
          <div className="advance-tab-input-label">Old Slave</div>
          <div className="advance-tab-input">
            <InputCreator
              type={"number"}
              value={oldPin}
              onChange={(e) => setOldPin(e.target.value)}
              large
              style={{border: "1px solid #d6d6d6", maxHeight: "38px", boxShadow: "none"}}
              data-cy={"old_slave"}
            />
          </div>
        </div>
        <div className="d-flex advance-tab-input-container">
          <div className="advance-tab-input-label">New Slave</div>
          <div className="advance-tab-input">
            <SelectCreator
              closeMenuOnSelect={true}
              options={slaveList}
              onChange={(e) => {
                setNewPin(e.target.value);
              }}
              value={newPin}
              colSize={12}
              placeholder={"Select New Slave"}
              classNamePrefix={"new_slave"}
              id={"new_slave"}
            />
          </div>
        </div>
        <div style={{display: "flex", justifyContent: "end", marginRight: "1rem"}}>
          <Button onClick={handleSubmit} data-cy={"submit-btn"}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SlaveAddressUtility;
